<template>
  <b-row>
    <b-col cols="12">
      <ticket-add-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import TicketAddForm from './TicketAddForm.vue'

export default {
  components: {
    BRow,
    BCol,
    TicketAddForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
